// Copyright (c) 2024 Merit International Inc. All Rights Reserved.

import { create } from "zustand";
import type { Notification } from "./types";

type NotificationsData = {
  readonly isInitialized: boolean;
  readonly notifications: readonly Notification[];
};

type NotificationsFunctions = {
  readonly dismissNotification: (notificationId: Notification["id"]) => void;
  readonly initialize: (notifications: readonly Notification[]) => void;
  readonly refresh: (notifications: readonly Notification[]) => void;
};

/* eslint-disable sort-keys-fix/sort-keys-fix */
const initialState: NotificationsData = {
  notifications: [],
  isInitialized: false,
};

export const useNotificationsStore = create<NotificationsData & NotificationsFunctions>()(
  (set, get) => ({
    ...initialState,

    dismissNotification: notificationId => {
      set(state => ({ notifications: state.notifications.filter(n => n.id !== notificationId) }));
    },

    initialize: notifications => {
      if (get().isInitialized) {
        return;
      }

      set(() => ({
        isInitialized: true,
        notifications,
      }));
    },

    refresh: notifications => {
      set(() => ({
        isInitialized: true,
        notifications,
      }));
    },
  })
);
/* eslint-enable sort-keys-fix/sort-keys-fix */
